import { getAllowedAdminDomains } from '@cdw-ae/common-data';
import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  firebase: {
    apiKey: 'AIzaSyAU1I2lfRbzoKjX4aeFZofeAgNeKTUmvig',
    authDomain: 'spog-gopher-testing.firebaseapp.com',
    projectId: 'spog-gopher-testing',
    storageBucket: 'spog-gopher-testing.firebasestorage.app',
    messagingSenderId: '303669706653',
    appId: '1:303669706653:web:bbd42426df2a96912eb974',
  },
  urls: {
    backendApi: 'https://spog-backend.test.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  // Client-side add-time domain allowlist (server is authoritative). Testing
  // does NOT permit the gafetest test domain.
  allowedAdminEmailDomains: getAllowedAdminDomains('testing'),
  revision: REVISION,
  version: VERSION,
};
